import type { ColumnDef } from '@tanstack/vue-table'
import { createSortableHeader } from './baseColumns'

export const createDateColumn = (
  accessorKey: string,
  id: string,
  title: string,
): ColumnDef<ManageUserTableRow> => {
  const columnSize = 250

  return {
    accessorKey,
    id,
    size: columnSize,
    enableSorting: true,
    header: createSortableHeader(title),
    cell: ({ row }) => {
      const date = row.original[accessorKey as keyof ManageUserTableRow] as string | null
      return h('div', { class: 'text-left text-md text-foreground' }, date || '-')
    },
  }
}
